'use client';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import DocumentTextIcon from '@flipster/react/icon/generated/DocumentTextIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { center, stack } from '@flipster/styled-system/patterns';

interface KolInsightsEmptyStateProps {
  css?: Styles;
  isSmall?: boolean;
}

export const KolInsightsEmptyState = ({ css: cssProps, isSmall = false }: KolInsightsEmptyStateProps) => {
  return (
    <div className={css(center.raw({ py: isSmall ? 40 : 80 }), cssProps)}>
      <div className={stack({ align: 'center', gap: isSmall ? 4 : 16, color: 'content.default.level-3' })}>
        <DocumentTextIcon size={isSmall ? 24 : 32} />
        <p
          className={css({
            textStyle: isSmall ? 'Body/L/Monospace/Regular' : 'Body/XL/Monospace/Regular',
            textAlign: 'center',
          })}
        >
          <FormattedMessage id='Home.r260831.New_insights_are_on_the_way' />
        </p>
      </div>
    </div>
  );
};

interface KolInsightsErrorStateProps {
  css?: Styles;
  isRetrying?: boolean;
  onRetry: () => void;
}

export const KolInsightsErrorState = ({ css: cssProps, isRetrying = false, onRetry }: KolInsightsErrorStateProps) => {
  return (
    <div className={css(center.raw({ py: 80 }), cssProps)}>
      <div className={stack({ align: 'center', gap: 16, color: 'content.default.level-3' })}>
        <DocumentTextIcon size={32} />
        <p className={css({ textStyle: 'Body/XL/Monospace/Regular', textAlign: 'center' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Something_went_wrong' />
        </p>
        <Button
          hierarchy='secondary'
          color='neutral'
          isLoading={isRetrying}
          withSpinner
          label={<FormattedMessage id='Autogen_common.r251126.s_Try_again' />}
          onClick={onRetry}
        />
      </div>
    </div>
  );
};
